import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePlaidLink, PlaidLinkOnSuccessMetadata, PlaidLinkError, PlaidLinkOnExitMetadata, PlaidLinkOnEventMetadata } from 'react-plaid-link';
import { postMessage, VoxSource, VoxEventType } from '../events';

export const PlaidEmbed = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  let linkToken: string | null = null;
  try {
    const parsedToken = JSON.parse(atob(token));
    linkToken = parsedToken?.linkToken || null;
    if (!linkToken) {
      postMessage({ eventType: VoxEventType.ERROR, payload: { error: 'Missing linkToken in token payload' }, _metadata: { source: VoxSource.PLAID, eventType: 'onError' } });
    }
  } catch (e) {
    console.error('Error decoding token:', e);
    postMessage({ eventType: VoxEventType.ERROR, payload: { error: e }, _metadata: { source: VoxSource.PLAID, eventType: 'onError' } });
  }

  const { open, ready, error } = usePlaidLink({
    token: linkToken,
    onSuccess: (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => {
      postMessage({ eventType: VoxEventType.COMPLETE, payload: { publicToken, metadata }, _metadata: { source: VoxSource.PLAID, eventType: 'onSuccess' } });
    },
    onExit: (error: PlaidLinkError | null, metadata: PlaidLinkOnExitMetadata) => {
      if (error) {
        postMessage({ eventType: VoxEventType.ERROR, payload: { error, metadata }, _metadata: { source: VoxSource.PLAID, eventType: 'onExit' } });
      } else {
        postMessage({ eventType: VoxEventType.COMPLETE, payload: { error, metadata }, _metadata: { source: VoxSource.PLAID, eventType: 'onExit' } });
      }
    },
    onEvent: (eventName: string, metadata: PlaidLinkOnEventMetadata) => {
      postMessage({ eventType: VoxEventType.UNDEFINED, payload: { eventName, metadata }, _metadata: { source: VoxSource.PLAID, eventType: `onEvent(${eventName})` } });
    },
    onLoad: () => {
      postMessage({ eventType: VoxEventType.LOAD, payload: null, _metadata: { source: VoxSource.PLAID, eventType: 'onLoad' } });
    },
  });

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  useEffect(() => {
    if (error) {
      postMessage({ eventType: VoxEventType.ERROR, payload: { error }, _metadata: { source: VoxSource.PLAID, eventType: 'onError' } });
    }
  }, [error]);

  return <div />;
};
